import { Flex, Spinner, Text } from "@chakra-ui/react";

interface LoaderProps {
	children: React.ReactNode;
}

export function Loader({ children = "Loading..." }: LoaderProps) {
	return (
		<Flex direction="row" gap={2} alignItems="center">
			<Spinner />
			<Text>{children}</Text>
		</Flex>
	);
}
